// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 888 ? "Auth" : chunkId) + "." + {"885":"6601be6c","888":"f862a7a8"}[chunkId] + ".chunk.css";
};